import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "footer-component",
  class: "d-flex align-items-start border-top border-white border-2 text-small text-white ps-2 pt-1 mb-1"
}
const _hoisted_2 = { class: "me-2" }
const _hoisted_3 = { class: "ms-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, "MPP © " + _toDisplayString(_ctx.currentDate), 1),
    _createElementVNode("p", {
      id: "footer-legal-label",
      class: "clickable",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/legal')))
    }, "Mentions legales "),
    _createElementVNode("p", _hoisted_3, "v" + _toDisplayString(_ctx.APP_VERSION), 1)
  ]))
}